import { ListOption } from '../../../../types/andTypes'

export const handleAndisByBusinessUnit = (
  andis: ListOption[],
  defaultBu: string,
  selectedBu: string,
  setBuANDis: (value: ListOption[]) => void
) => {
  const andisByBu = andis.filter(
    andi => andi.businessUnit === defaultBu || andi.businessUnit === selectedBu
  )

  setBuANDis(andisByBu)
}
